// =========================================================
// DATX High-Performance Route Preloader
// Automatically fetches page chunk bundles on hover / touch
// =========================================================

const routeLoaders = {
  '/': () => import('../pages/Home'),
  '/courses': () => import('../pages/Courses'),
  '/tracks': () => import('../pages/Tracks'),
  '/diplomas': () => import('../pages/Tracks'),
  '/paths': () => import('../pages/CareerPathsPage'),
  '/career-paths': () => import('../pages/CareerPathsPage'),
  '/seminars': () => import('../pages/Webinars'),
  '/webinars': () => import('../pages/Webinars'),
  '/about': () => import('../pages/About'),
  '/services': () => import('../pages/Services'),
  '/contact': () => import('../pages/Contact'),
  '/blog': () => import('../pages/Blog'),
  '/payment-methods': () => import('../pages/PaymentMethodsPage'),
  '/privacy': () => import('../pages/PrivacyPolicyPage'),
  '/privacy-policy': () => import('../pages/PrivacyPolicyPage'),
  '/terms': () => import('../pages/TermsPage'),
  '/terms-of-service': () => import('../pages/TermsPage'),
  '/cookies': () => import('../pages/CookiePolicyPage'),
  '/cookie-policy': () => import('../pages/CookiePolicyPage'),
  '/verify': () => import('../pages/PublicCertificateVerificationPage'),
  '/corporate-request': () => import('../pages/CorporateRequestPage'),
  '/my-learning': () => import('../pages/StudentMyLearningPage'),
  '/student/certificates': () => import('../pages/StudentCertificatesPage'),
};

const preloadedRoutes = new Set();

/**
 * Preloads the javascript code chunk for the target route silently.
 * Triggered on link mouseEnter, touchStart, or focus.
 */
export const preloadRoute = (path) => {
  if (!path || typeof path !== 'string') return;
  const cleanPath = path.split('?')[0].split('#')[0];
  
  if (preloadedRoutes.has(cleanPath)) return;

  const loader = routeLoaders[cleanPath];
  if (loader) {
    preloadedRoutes.add(cleanPath);
    try {
      // Use requestIdleCallback if available for zero CPU contention
      if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
        window.requestIdleCallback(() => loader(), { timeout: 1500 });
      } else {
        setTimeout(() => loader(), 10);
      }
    } catch (e) {
      // graceful fallback
    }
  }
};
